import React from 'react'
import { Link, useHistory } from "react-router-dom";
import { faUserCircle, faSignOutAlt, faKey } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Swal from "sweetalert2";
import axios from "axios";
import { apiUrl, url_web } from '../constants';

export default function Menu(props) {
    const history = useHistory();
    const queryString = require('query-string');

    // console.log(props)
    return (
        <div className="dropdown">
            <div id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {/* <FontAwesomeIcon icon={faUserCircle} size="2x" /> */}
            </div>

            <div className="dropdown-menu" aria-labelledby="dropdownMenu2" style={{ transition: "all 0.3s ease-out" }}>
                <button className="dropdown-item" type="button"
                    onClick={() => {
                        let link = window.location.href = `callback?change_password=true`
                    }}
                >
                    <FontAwesomeIcon icon={faKey} size="1x" style={{ marginRight: "10px" }} />
                Change password</button>
                <button className="dropdown-item" type="button"
                    onClick={() => {
                        localStorage.removeItem('events_tco');
                        localStorage.removeItem('events_tyc');
                        localStorage.removeItem('token');
                        localStorage.removeItem("modeCal")
                        localStorage.removeItem("history")
                        
                        let link = window.location.href = `callback?logout=true`
                    }}
                >
                    <FontAwesomeIcon icon={faSignOutAlt} size="1x" style={{ marginRight: "10px" }} />
                Logout</button>
            </div>
        </div>
    )
}
